import { FULL_HD, HD } from '@bedrock-rdk/constants';
import Icon from '../../../icon/icon.component';
import { Badge } from '../../../badge/badge.component';
import { ICON_POSITION } from '../../../utils/templates';

export const ICONS = {
  [ICON_POSITION.TOP_LEFT]: 2,
  [ICON_POSITION.TOP_RIGHT]: 4,
};

export const ICONS_TYPES = {
  [ICON_POSITION.TOP_LEFT]: Icon,
  [ICON_POSITION.TOP_RIGHT]: Badge,
  [ICON_POSITION.BOTTOM_RIGHT]: Icon,
};

export const DISPLAY_PROGRESS = true;

export const ITEMS_BY_BREAKPOINTS = {
  general: {
    [HD]: 5,
    [FULL_HD]: 6,
  },
  search: {
    [HD]: 4,
    [FULL_HD]: 4,
  },
};
